import {Component, Input} from '@angular/core';
import {ImageCarouselDialogComponent} from "../image-carousel-dialog/image-carousel-dialog.component";
import { MatDialog } from '@angular/material/dialog';

export interface ImageItem {
    id: number;
    name: string;
    url: string;
}

@Component({
  selector: 'app-image-gallery',
  templateUrl: './image-gallery.component.html',
  styleUrls: ['./image-gallery.component.scss']
})
export class ImageGalleryComponent {
    @Input() images: ImageItem[] = [];
    @Input() badge = '';

    constructor(private dialog: MatDialog) {}

    get previewImages(): ImageItem[] {
        return this.images?.slice(0, 5) ?? [];
    }

    get hasMoreImages(): boolean {
        return (this.images?.length ?? 0) > 5;
    }

    openGallery(): void {
        if (!this.images?.length) {
            return;
        }
        this.dialog.open(ImageCarouselDialogComponent, {
            data: this.images,
            panelClass: 'fullscreen-dialog',
            maxWidth: '100vw',
            maxHeight: '100vh',
            height: '100%',
            width: '100%'
        });
    }
}
